<template>
  <b-container v-if="success" fluid class="container">
    <modal-form
      :visible="visibleModalForm"
      :title="'Registrar Etiqueta'"
      :size="'lg'"
      @hide="closeModalForm"
    >
      <a-spin :spinning="loadingForm">
        <div class="container">
          <b-form @submit.stop.prevent="saveFileDescription">
            <div class="row">
              <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <strong>
                  <label for="descripcion">Descripción Etiqueta :</label>
                </strong>
                <b-form-group label-for="descripcion" :invalid-feedback="errors.first('descripcion')" :state="!errors.has('descripcion')">
                  <b-form-input 
                    v-model="description"
                    :state="errors.has('descripcion') ? false : null"
                    v-validate="'required|max:128'"
                    data-vv-name="descripcion"
                    data-vv-as="descripción"
                    type="text"
                  ></b-form-input>
                </b-form-group>
              </div>
            </div>
            <div class="row my-2">
              <div class="col-12 col-md-12 col-lg-12 col-xl-12">
                <b-button 
                  type="submit" 
                  class="float-right" 
                  variant="success"
                ><i class="fa fa-check-circle" aria-hidden="true"></i> REGISTRAR</b-button>
                <b-button @click="closeModalForm" class="mr-2 float-right" variant="secondary"><i class="fa fa-times-circle" aria-hidden="true"></i> CANCELAR</b-button>
              </div>
            </div>
          </b-form>
        </div>
      </a-spin>
    </modal-form>
    <b-row class="row">
      <b-col class="column" lg="2">
        <b-form-group>
          <div class="input-container">
            <b-form-input
              v-model="codigoCarpeta"
              @keyup.enter="getDigitalFolders"
              size="sm"
              placeholder="DUI, DIM, N° de Interno"
              type="text"
            ></b-form-input>
            <button
              @click="clearInputCodigo"
              class="btn btn-link btn-clear-input"
            >
              <i class="fa fa-times-circle fa-lg"></i>
            </button>
          </div>
        </b-form-group>
        <vue-custom-scrollbar class="scroll-area"  :settings="settings">
          <ul class="tree">
            <tree-node v-for="node in cajas" :key="node.id" :node="node" @child-click="handleChildClick"/>
          </ul>
        </vue-custom-scrollbar>
      </b-col>
      <b-col class="column" lg="8">
        <div v-if="itemsFiles.length > 0 || checkConfig == false">
          <div class="p-2 mb-2 bg-light text-dark d-flex justify-content-between align-items-center">
            <div class="d-flex">
              <b-popover
                target="detele-item"
                triggers="click"
                :show.sync="popoverShow"
                placement="auto"
                ref="popover"
              >
                <a-alert
                  message="Alerta"
                  :description="'Realmente desea eliminar estos documentos?'"
                  type="warning"
                  showIcon
                />
                <br /> 
                <div>
                  <b-button  class="mr-2" squared @click="popoverShow = !popoverShow" size="sm" variant="outline-secondary">Cancelar</b-button>
                  <b-button squared @click="deleteFileById" size="sm" variant="danger">Si</b-button>
                </div>
              </b-popover>
              <b-button
                :disabled="!this.selectedThumbnails.length > 0"
                id="detele-item"
                variant="danger"
                size="sm"
              >({{ selectedThumbnails.length }}) Eliminar</b-button>
              <div class="ml-2">
                <div class="clear-container">
                  <input
                    v-model="descriptionFile"
                    @keyup.enter="getFileFolder"
                    class="form-control"
                    placeholder="Buscar.."
                    type="text"
                  />
                  <button v-if="descriptionFile" @click="clearInputSearchFile" class="clear-button" title="Limpiar">
                    <i class="fa fa-times-circle fa-lg"></i>
                  </button>
                </div>
              </div>
            </div>

            <div>
              <b-dropdown :disabled="!this.itemsFiles.length > 0" size="sm" class="w-auto mr-2">
                <template #button-content>
                  <i class="fa fa-download"></i>
                </template>
                <b-dropdown-item-button @click="downloadDigital1Zip">Descarga RD-01-008</b-dropdown-item-button>
                <b-dropdown-item-button @click="downloadDigital2Zip">Descarga RD-01-2023</b-dropdown-item-button>
              </b-dropdown>

              <b-form-select v-model="selected" :options="grupos" size="sm" class="w-auto mr-2">
                <template #first>
                  <b-form-select-option :value="null" disabled>-- Seleccion un grupo --</b-form-select-option>
                </template>
              </b-form-select>
              <button :disabled="!this.itemsFiles.length > 0" @click="updateFileById" class="btn btn-success btn-sm">
                <i class="fa fa-check-circle"></i> Guardar Cambios
              </button>
            </div>
          </div>
          <!-- <pre>{{ thumbnails }}</pre> -->
          <vue-custom-scrollbar v-if="checkConfig" class="scroll-area" :settings="settings">
            <div class="thumbnail-list">
              <draggable v-model="itemsFiles" :element="'div'" @end="onDragEnd" class="draggable-container">
                <div v-for="(item, index) in itemsFiles" :key="item._id.$oid" class="thumbnail-item" :style="{ backgroundColor: getBackgroundColor(item.group) }">
                  <div class="thumbnail-wrapper">
                    <img :src="addPrefixToBase64(item.thumbnail_info)" @click="openLightbox(index)" />
                    <div class="hover-caption" :class="{ 'active': isHovered(index) }">
                      <input type="checkbox" :checked="selectedThumbnails.includes(index)" @change="toggleSelection(index, item)" @click.stop />
                      <button @click="openLightbox(index)" class="btn btn-success btn-sm">
                        <i class="fa fa-external-link"></i>
                      </button>
                      <div class="caption-text">
                        Folio n°: {{ item.order }}
                      </div>
                    </div>
                    <button @click="openModalForm(item)" class="btn btn-info btn-sm btn-top-right">
                      <i class="fa fa-tag"></i>
                    </button>
                  </div>
                </div>
              </draggable>
            </div>
          </vue-custom-scrollbar>
          <div v-else class="text-center mt-5">
            <i class="fa fa-exclamation-circle fa-5x text-danger"></i>
            <p class="mt-2 font-weight-bold">Sin resultados</p>
          </div>
        </div>
      </b-col>
      <b-col class="column info-column" lg="2">
        <div v-if="folderDetail">
          <div class="info-title">Detalles</div>
          <div class="info-item">
            <div class="info-subtitle">N° Declaración:</div>
            <div class="info-value">{{ folderDetail.nro_declaracion }}</div>
          </div>
          <div class="info-item">
            <div class="info-subtitle">N° Registro:</div>
            <div class="info-value">{{ folderDetail.nro_registro }}</div>
          </div>
          <div class="info-item">
            <div class="info-subtitle">Aduana Trámite:</div>
            <div class="info-value">{{ folderDetail.aduana_tramite }}</div>
          </div>
          <div class="info-item">
            <div class="info-subtitle">Fecha de Aceptación:</div>
            <div class="info-value">{{ folderDetail.fecha_aceptacion }}</div>
          </div>
          <div class="info-item">
            <div class="info-subtitle">Régimen Aduanero:</div>
            <div class="info-value">{{ folderDetail.regimen_aduanero }}</div>
          </div>
          <div class="info-item">
            <div class="info-subtitle">Modalidad del Régimen:</div>
            <div class="info-value">{{ folderDetail.modalidad_regimen }}</div>
          </div>
          <div class="info-item">
            <div class="info-subtitle">Modalidad de Despacho:</div>
            <div class="info-value">{{ folderDetail.modalidad_despacho }}</div>
          </div>
          <div class="info-item">
            <div class="info-subtitle">Importador:</div>
            <div class="info-value">{{ folderDetail.importador }}</div>
          </div>
          <div class="info-item">
            <div class="info-subtitle">Declarante:</div>
            <div class="info-value">{{ folderDetail.declarante }}</div>
          </div>
          <div class="info-item">
            <div class="info-subtitle">País de Exportación:</div>
            <div class="info-value">{{ folderDetail.pais_exportacion }}</div>
          </div>
          <div class="info-item">
            <div class="info-subtitle">Aduana de Ingreso:</div>
            <div class="info-value">{{ folderDetail.aduana_ingreso }}</div>
          </div>
          <div class="info-item">
            <div class="info-subtitle">Total N° Facturas:</div>
            <div class="info-value">{{ folderDetail.total_nro_facturas }}</div>
          </div>
          <div class="info-item">
            <div class="info-subtitle">Total N° Items:</div>
            <div class="info-value">{{ folderDetail.total_nro_items }}</div>
          </div>
          <div class="info-item">
            <div class="info-subtitle">Total N° Bultos:</div>
            <div class="info-value">{{ folderDetail.total_nro_bultos }}</div>
          </div>
          <div class="info-item">
            <div class="info-subtitle">Total Peso(kg):</div>
            <div class="info-value">{{ folderDetail.total_peso_bruto }}</div>
          </div>
          <div class="info-item">
            <div class="info-subtitle">Total Valor FOB(USD):</div>
            <div class="info-value">{{ folderDetail.total_valor_fob }}</div>
          </div>
          <div class="info-item">
            <div class="info-subtitle">Cantidad de Documentos:</div>
            <div class="info-value">{{ folderDetail.cantidad_documentos }}</div>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import TreeNode from '../../components/widgets/Tree/TreeNode.vue';
  import BoxService from '../../services/box.service'
  import GroupService from '../../services/grupo.service'
  import ModalForm from "../../components/widgets/Modals/ModalForm"
  import draggable from 'vuedraggable';
  import 'lightgallery.js';
  import 'lg-zoom.js';
  import 'lg-fullscreen.js';
  import 'lg-rotate.js';
  import 'lightgallery.js/dist/css/lightgallery.css';
  import vueCustomScrollbar from 'vue-custom-scrollbar'
  import "vue-custom-scrollbar/dist/vueScrollbar.css"

  export default {
    data() {
      return {
        success: false,
        checkConfig: true,
        cajas: [],
        itemsFiles: [],
        fileId: null,
        documentId: null,
        selectedThumbnails: [],
        selectedData: [],
        popoverShow: false,
        selected: null,
        grupos: [],
        settings: {
          suppressScrollY: false,
          suppressScrollX: false,
          wheelPropagation: false
        },
        codigoCarpeta: '',
        folderDetail: null,
        visibleModalForm: false,
        loadingForm: false,
        description: '',
        descriptionFile: '',
      };
    },

    computed: {
      ...mapGetters([
        'currentUser'
      ])
    },

    components: {
      TreeNode,
      vueCustomScrollbar,
      draggable,
      "modal-form": ModalForm,
    },

    created() {
      Promise.all([this.listGrupos(), this.getDigitalFolders()])
        .then(() =>{
          this.success = true
        })
    },

    methods: {
      async downloadDigital1Zip() {
        this.$store.dispatch("showLoader")
        try {
          const response = await BoxService.downloadDigital1Zip(this.itemsFiles[0].general_doc_id, this.folderDetail.nro_declaracion, this.folderDetail.gestion, this.folderDetail.aduana_codigo, this.currentUser.agencia)
          if (response.status === 200) {
            const blob = new Blob([response.data], { type: 'application/zip' });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = `${this.folderDetail.gestion}_${this.folderDetail.nro_declaracion}.zip`;
            link.click();
            
            window.URL.revokeObjectURL(link.href);
            this.$store.dispatch("hideLoader")
          }
        } catch (err) {
          this.$store.dispatch("hideLoader")
        }
        console.log()
      },

      async downloadDigital2Zip() {
        this.$store.dispatch("showLoader")
        try {
          const response = await BoxService.downloadDigital2Zip(this.itemsFiles[0].general_doc_id, this.folderDetail.nro_declaracion, this.folderDetail.gestion, this.folderDetail.aduana_codigo, this.currentUser.agencia)
          if (response.status === 200) {
            const blob = new Blob([response.data], { type: 'application/zip' });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = `${this.folderDetail.gestion}_${this.folderDetail.nro_declaracion}.zip`;
            link.click();
            
            window.URL.revokeObjectURL(link.href);
            this.$store.dispatch("hideLoader")
          }
        } catch (err) {
          this.$store.dispatch("hideLoader")
        }
      },

      async saveFileDescription() {
        this.loadingForm = true
        try {
          const response = await BoxService.saveFileDescription({file_id: this.fileId, description: this.description})
          if (response.status === 200) {
            this.closeModalForm()
            this.loadingForm = false
            this.$message.success(response.data.message)
          }
        } catch (err) {
          if(err.response.status === 422) this.$setErrorsFromResponse(err.response.data)
          this.closeModalForm()
          this.loadingForm = false
        }
      },

      async getFileFolder() {
        this.$store.dispatch("showLoader")
        try {
          if (this.descriptionFile != '') {
            let document = this.itemsFiles[0]
            const request = await BoxService.getFileFolder(`files/search?folder_id=${document.general_doc_id}&tag=${this.descriptionFile}`)
            if (request.status === 200) {
              this.itemsFiles = request.data.data
              if (!this.itemsFiles.length > 0) {
                this.checkConfig = false
              }
              this.$store.dispatch("hideLoader")
            }
          } else {
            this.clearInputSearchFile()
          }
        } catch (err) {
          this.$store.dispatch("hideLoader")
        }
      },

      clearInputCodigo() {
        this.codigoCarpeta = ''
        this.getDigitalFolders()
      },

      clearInputSearchFile() {
        this.descriptionFile = ''
        this.handleChildClick(this.documentId)
      },

      openModalForm(item) {
        this.fileId = item._id.$oid
        this.description = item.description
        this.visibleModalForm = true
      },

      closeModalForm() {
        this.fileId = null
        this.description = ''
        this.visibleModalForm = false
      },

      listGrupos: async function() {
        const request = await GroupService.listGrupos();
        if (request.status === 200) {
          this.grupos = request.data
        }
      },

      getDigitalFolders:async function() {
        this.$store.dispatch("showLoader")
        try {
          if (this.codigoCarpeta == '') {
            const request = await BoxService.getDigitalFolders('cajas/agencia')
            if (request.status === 200) {
              let data = request.data.data
              // Recorre los elementos en el array
              data.forEach(grandparent => {
                  if (grandparent.children) {
                      grandparent.children.forEach(parent => {
                          // Verifica si al menos un child tiene digitalizado true
                          const hasDigitalizado = parent.children && parent.children.some(child => child.digitalizado === true);

                          // Agrega la propiedad digitalizado al parent según la condición
                          parent.digitalizado = hasDigitalizado;
                      });
                  }
              });
              this.cajas = data
              this.$store.dispatch("hideLoader")
            }
          } else {
            const request = await BoxService.getDigitalFolders(`cajas/agencia?nro=${this.codigoCarpeta}`)
            if (request.status === 200) {
              this.cajas = request.data.data
              this.$store.dispatch("hideLoader")
            }
          }
        } catch (err) {
          this.$store.dispatch("hideLoader")
        }
      },
    
      async handleChildClick(documentId) {
        this.documentId = documentId
        this.$store.dispatch("showLoader")
        try {
          const response = await BoxService.getFilesByFolderId(`folder/files/${documentId}`)
          if (response.status === 200) {
            this.itemsFiles = response.data.data
            this.folderDetail = response.data.folder
            if (this.itemsFiles.length > 0) {
              this.checkConfig = true
            }
            this.$store.dispatch("hideLoader")
          }
        } catch (err) {
          if (err.response.status === 404) {
            this.itemsFiles = []
            this.checkConfig = false
          }
          this.$store.dispatch("hideLoader")
        }
      },

      async updateFileById() {
        this.$store.dispatch("showLoader")
        try {
          const response = await BoxService.updateFileById({files: this.itemsFiles, selected: this.selectedData.map(i => i._id.$oid), type: this.selected})
          if (response.status === 200) {
            this.selectedThumbnails = []
            this.selectedData = []
            this.selected = null
            this.handleChildClick(this.documentId)
            this.$store.dispatch("hideLoader")
          }
        } catch (err) {
          this.$store.dispatch("hideLoader")
        }
      },

      async deleteFileById() {
        this.$store.dispatch("showLoader")
        let ids = this.selectedData.map(i => i._id.$oid)
        try {
          const response = await BoxService.deleteFileById({file_ids: ids})
          if (response.status === 200) {
            this.selectedThumbnails = []
            this.selectedData = []
            this.popoverShow = false
            this.handleChildClick(this.fileId)
            this.$store.dispatch("hideLoader")
          }
        } catch (err) {
          this.$store.dispatch("hideLoader")
        }
      },

      toggleSelection(index, thumbnail) {
        const selectedIndex = this.selectedThumbnails.indexOf(index);

        if (selectedIndex !== -1) {
          this.selectedThumbnails.splice(selectedIndex, 1);
          this.selectedData = this.selectedData.filter(
            (selectedThumbnail) => selectedThumbnail._id.$oid !== thumbnail._id.$oid
          );
        } else {
          this.selectedThumbnails.push(index);
          this.selectedData.push(thumbnail);
        }
      },

      isHovered(index) {
        return this.hoveredIndex === index || this.selectedThumbnails.includes(index);
      },

      openLightbox(index) {
        if (!window.lightGallery) {
          return;
        }

        const galleryOptions = {
          dynamic: true,
          dynamicEl: this.itemsFiles.map((item) => ({
            src: this.addPrefixToBase64(item.thumbnail_info),
          })),
          index: index,
          zoom: true,
          fullScreen: true,
          rotate: true,
        };

        window.lightGallery(document.createElement('div'), galleryOptions);
      },

      getBackgroundColor(group) {
        switch (group) {
          case 1:
            return '#594747';
          case 2:
            return '#259073';
          case 3:
            return '#f77c3e';
          case 4:
            return '#e7d84b';
          case 5:
            return '#2011ab';
          case 6:
            return '#FF1B1B';
          case 7:
            return '#86FF51';
          case 8:
            return '#00F7FF';
          default:
            return 'gray';
        }
      },

      onDragEnd(event) {
        this.itemsFiles.forEach((item, index) => {
          const newIndex = this.itemsFiles.findIndex((t) => t._id.$oid === item._id.$oid);
          item.order = newIndex + 1;
        });
      },
      
      addPrefixToBase64(base64String) {
        return `data:image/png;base64,${base64String}`;
      },
    },
  };
</script>

<style scoped>
  .btn-top-right {
    position: absolute;
    top: 5px;
    right: 5px;
    z-index: 2; /* Asegura que el botón esté encima de la miniatura */
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  .thumbnail-wrapper:hover .btn-top-right {
    opacity: 1;
  }

  .info-column {
    text-align: center;
  }

  .info-title {
    font-size: 0.9rem; /* Ajusta según sea necesario */
    margin-bottom: 0.3rem; /* Ajusta según sea necesario */
    text-align: center; /* Centra el texto del título */
    font-weight: bold;
  }

  .info-subtitle {
    font-size: 0.7rem; /* Ajusta según sea necesario */
    margin-bottom: 0.4rem; /* Ajusta según sea necesario */
    font-weight: bold;
    text-align: left;
  }

  .info-item {
    display: flex;
    justify-content: space-between;
  }

  .info-value {
    font-size: 0.6rem; /* Ajusta según sea necesario */
    text-align: right; /* Asegura que el texto esté alineado a la izquierda dentro de los elementos de información */
  }

  .scroll-area {
    position: relative;
    margin: auto;
    height: 400px;
  }

  .container {
    height: 100%; /* Establece la altura del contenedor principal al 100% de la altura de la pantalla */
  }

  .row {
    height: 100%; /* Establece la altura de la fila al 100% de la altura del contenedor */
  }

  .column {
    border: 1px solid #ccc; /* Añade un borde para visualización */
    padding: 10px; /* Añade un espacio interno */
    height: 100%; /* Establece la altura de las columnas al 100% de la altura de la fila */
    overflow-y: hidden; /* Inicialmente, oculta el desplazamiento vertical */
  }

  .tree {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .thumbnail-list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .draggable-container {
    width: 100%; /* Ajusta según sea necesario */
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .thumbnail-item {
    width: 120px;
    height: 180px;
    overflow: hidden;
    box-sizing: border-box; /* Incluye el padding en el tamaño total del contenedor */
  }
  .thumbnail-item img {
    width: 100%;
    height: 100%;
    display: block;
    padding: 3px; /* Añade padding alrededor de cada imagen */
  }

  .thumbnail-wrapper {
    position: relative;
    display: inline-block;
    width: 120px;
    height: 180px;
    overflow: hidden;
  }
  
  .hover-caption {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgb(120 120 120 / 70%);
    display: flex;
    justify-content: center; /* Centra los elementos horizontalmente */
    align-items: flex-end; /* Alinea los elementos en la parte inferior */
    padding: 5px;
    opacity: 0;
    transition: opacity 0.3s ease;
  }
  
  .thumbnail-wrapper:hover .hover-caption,
  .hover-caption.active {
    opacity: 1;
  }

  .hover-caption input[type="checkbox"] {
    margin: 0 5px;
    width: 28px; 
    height: 28px; 
  }

  .hover-caption button {
    margin: 0 5px;
    width: 28px; 
    height: 28px; 
  }

  .caption-text {
    color: #fff; /* Texto blanco */
    font-size: 14px; /* Ajusta según sea necesario */
    text-align: center; /* Centra el texto horizontalmente */
    position: absolute;
    font-weight: bold;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .btn-clear-input {
    position: absolute;
    top: 5%;
    right: 15px;
    transform: translateY(-50%);
    background: transparent;
    border: none;
    cursor: pointer;
    display: none;
  }

  .input-container:hover .btn-clear-input {
    display: block;
  }

  .clear-container {
    position: relative;
  }

  .clear-button {
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    cursor: pointer;
    display: none;
  }

  .clear-container:hover .clear-button {
    display: block;
  }
</style>
